var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.916,
    height: 18.634,
    viewBox: "0 0 26.916 18.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-122.5 -122.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.57,122.5a2.07,2.07,0,1,0,1.464.606A2.071,2.071,0,0,0,124.57,122.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.877,142.127H242.37a1.061,1.061,0,1,0,0-2.122H227.877a1.077,1.077,0,1,0,0,2.153Z",
    transform: "translate(-98.13 -16.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.57,245a2.07,2.07,0,1,0,1.464.606A2.071,2.071,0,0,0,124.57,245Z",
    transform: "translate(0 -115.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.535,264.57h10.352a1.035,1.035,0,1,0,0-2.07H228.535a1.035,1.035,0,1,0,0,2.07Z",
    transform: "translate(-98.789 -131.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.57,367.5a2.07,2.07,0,1,0,1.464.606A2.071,2.071,0,0,0,124.57,367.5Z",
    transform: "translate(0 -230.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.17,385H228.535a1.035,1.035,0,1,0,0,2.07H247.17a1.035,1.035,0,1,0,0-2.07Z",
    transform: "translate(-98.789 -246.971)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenu);
export default __webpack_public_path__ + "static/media/mobile-menu.03fa1d191560ae4acc629fe2666326ef.svg";
export { ForwardRef as ReactComponent };